import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import { Col, message, Row, Select, Space } from 'antd';
import { api, endpoints } from '../../../../api';
import { AppearBlock, CloseButton, CustomSelect, DownloadCol, FormItem } from '../../../../styles/styled';
import { UploadComponent } from '../../../NewApplicationPage/components/BookRegistrationComponent/components/BookForm/UploadComponent';
import { FileEditorData } from '../../../NewApplicationPage/components/BookRegistrationComponent/components/BookForm/UploadComponent/UploadComponent';
import { CreateFileRequestType, FileDataType } from '../../../NewApplicationPage/types';
import { ExpertDegree } from '../../types';
import { ScienceBranchesType } from './types';

type AcademicDegreeProps = {
  removeForm: (id: number) => void;
  id: number;
  updateForm: (expertDegree: ExpertDegree, id: number) => void;
  inputData?: ExpertDegree;
  academicDegrees: ScienceBranchesType;
  genScienceBranches: ScienceBranchesType;
};

const { Option } = Select;

export const AcademicDegreeForm: FC<AcademicDegreeProps> = ({
  academicDegrees,
  genScienceBranches,
  removeForm,
  inputData,
  id,
  updateForm,
}) => {
  const [inputsState, setInputsState] = useState<ExpertDegree>(
    inputData || {
      academic_degree: {
        id: 0,
      },
      branch_of_science: {
        id: 0,
      },
      file: { id: 0 },
    },
  );

  const [academicFileState, setAcademicFile] = useState<CreateFileRequestType | null>();
  const firstUpdate = useRef(false);

  const uploadFiles = useCallback(async (fileData: FileDataType) => {
    try {
      const response = await api
        .post<{ success: boolean; file_id: number }>(endpoints.addFile(), {
          ...fileData,
          ext: fileData.title.split('.').pop(),
        })
        .then((el) => {
          return el;
        })
        .catch(() => message.error('Произошла ошибка при загрузке файла'));

      if (response) {
        setInputsState((prevState) => {
          return { ...prevState, file: { id: response.data.file_id } };
        });

        setAcademicFile({ title: fileData.title, base64: fileData.base64, ext: fileData.ext });
      }
    } catch (err) {
      message.error('Произошла ошибка загрузки файла');
    }
  }, []);

  const beforeUploadFile = async (data: FileEditorData) => {
    await uploadFiles({
      base64: data.data.split('base64,')[1],
      title: data.name as string,
      ext: data.type as string,
    });
  };

  useEffect(() => {
    if (firstUpdate.current) {
      updateForm(
        {
          academic_degree: inputsState.academic_degree,
          branch_of_science: inputsState.branch_of_science,
          file: inputsState.file || { id: 0 },
        },
        id,
      );
    }

    firstUpdate.current = true;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputsState]);

  return (
    <AppearBlock padding="40px 20px">
      <CloseButton positioned onClick={() => removeForm(id)}>
        +
      </CloseButton>
      <Row gutter={[20, 20]}>
        <Col span={24}>
          <FormItem direction="row">
            <p>Учёная степень</p>
            <CustomSelect
              onChange={(value, option) => {
                setInputsState({
                  ...inputsState,
                  academic_degree: value ? { id: parseInt(Object.values(option)[0]) } : undefined,
                });
              }}
              value={
                (inputsState.academic_degree &&
                  academicDegrees.find((el) => el.id === inputsState?.academic_degree?.id)?.title) ||
                ''
              }
              showSearch
              allowClear
            >
              <Option key={undefined} value={undefined}>
                Все
              </Option>
              {academicDegrees.map((el) => {
                return (
                  <Option key={el.id} value={el.title}>
                    {el.title}
                  </Option>
                );
              })}
            </CustomSelect>
          </FormItem>
        </Col>
        <Col span={24}>
          <FormItem direction="row">
            <p>Отрасль науки</p>
            <CustomSelect
              onChange={(value, option) => {
                setInputsState({
                  ...inputsState,
                  branch_of_science: value ? { id: parseInt(Object.values(option)[0]) } : undefined,
                });
              }}
              value={
                (inputsState.branch_of_science &&
                  genScienceBranches.find((el) => el.id === inputsState?.branch_of_science?.id)?.title) ||
                ''
              }
              showSearch
              allowClear
            >
              <Option key={undefined} value={undefined}>
                Все
              </Option>
              {genScienceBranches.map((el) => {
                return (
                  <Option key={el.id} value={el.title}>
                    {el.title}
                  </Option>
                );
              })}
            </CustomSelect>
          </FormItem>
        </Col>
        <Col span={24}>
          <DownloadCol span={24} style={{ paddingLeft: '35px' }}>
            <Space align="center">
              <UploadComponent
                onClear={() => setAcademicFile(null)}
                value={
                  academicFileState && inputsState.file
                    ? { title: academicFileState.title, id: inputsState.file.id }
                    : undefined
                }
                formats={['.pdf']}
                onChange={beforeUploadFile}
              />
            </Space>
            <p>рекомендуется прикреплять файл в формате .pdf</p>
          </DownloadCol>
        </Col>
      </Row>
    </AppearBlock>
  );
};
